import { ThemeProvider as MatchboxThemeProvider } from '@sparkpost/matchbox';

/**
 * Matchbox ThemeProvider component.
 * @see https://design.sparkpost.com/components/themeprovider/
 */
const ThemeProvider = MatchboxThemeProvider;

export default ThemeProvider;
